<template>
  <v-dialog
    v-model="cartDialog"
    max-width="600"
    persistent
    :fullscreen="$vuetify.breakpoint.name=='xs'"
    scrollable
  >
    <v-card
      flat
      light
      rounded
    >
      <v-toolbar
        flat
        class="d-flex"
        color="white"
      >
        <v-btn
          icon
          @click="closeCartDialog"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-card-title>
          {{ title }}
        </v-card-title>
      </v-toolbar>
    
      <v-card-text
        class="pb-0"
      >
        <receipt
          v-if="showInvoice"
        />
        <cart
          v-if="!showInvoice"
          @success="checkoutSuccess"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Cart from './Cart';
import Receipt from './Receipt';

export default {
  components: {
    Cart,
    Receipt,
  },
  data() {
    return {
      showInvoice: false
    }
  },
  computed: {
    cartDialog:{
      get(){return this.$store.state.market.cartDialog},
      set(v){this.$store.commit('market/openCloseCartDialog', v)}
    },
    title(){return this.showInvoice ? 'Receipt' : 'Cart'}
  },
  methods: {
    checkoutSuccess(){
      this.$store.commit('market/emptyCart', this.context)
      this.showInvoice = true
    },
    closeCartDialog(){
      this.cartDialog = this.showInvoice = false
    }
  }
}
</script>
